import * as classNames from "classnames"

interface Props {
    value: string
    onChange: (value: any) => void
    isTextAreaBlank: boolean
    textAreaData: any
    isChecked: boolean
}
export class TextArea extends React.Component<Props, State> {

    render() {
        const { value, onChange, isTextAreaBlank, textAreaData, isChecked } = this.props
        return (
            <div id="RedMailTextAreaElement" className="RedMailTextArea">
                <div className="redMailTextAreaTop">
                    <p className="TextAreaHeadline">{textAreaData.textAreaHeadline}</p>
                    {isChecked &&
                        <div className="shareButtonsWrapper">
                            <a href="https://wa.me/972548243550" className="whatsappButton" target="_blank">
                                <img />
                                <div>וואטסאפ</div>
                            </a>
                            <a href="https://t.me/ynetTbot" className="telegramButton" target="_blank">
                                <img />
                                <div>טלגרם</div>
                            </a>
                        </div>
                    }
                </div>
                <div className="textAreaWrapper">
                    <textarea dir="rtl" placeholder={textAreaData.placeholder} value={value} resize="vertical" onChange={(e) => onChange(e)} required className={classNames("textAre", { "placeholderErrorStyle": isTextAreaBlank })}></textarea>
                </div>
            </div>
        )
    }
}